// import React, { useState } from "react";
// import {
//   Card,
//   CardContent,
//   CardMedia,
//   Typography,
//   Box,
//   IconButton,
//   Menu,
//   MenuItem,
//   Divider,
//   LinearProgress,
//   Stack,
// } from "@mui/material";
// import { ArrowUpward, MoreVert } from "@mui/icons-material";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
// import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";
// import { SampleImageCard } from "../../assets/images";

// const AdminProductCard = ({
//   title,
//   summary,
//   price,
//   sales,
//   remaining,
//   image,
//   sx,
//   data,
// }) => {
//   // Menu State
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const open = Boolean(anchorEl);

//   return (
//     <Card
//       sx={{
//         width: 320,
//         // height: 320,
//         margin: 2,
//         borderRadius: 2,
//         boxShadow: 3,
//         overflow: "hidden",
        
//       }}
//     >
//       <Box
//         sx={{
//           height: "30%",
//           display: "flex",
//           flexDirection: "row",
//           justifyContent: "space-evenly",
//         }}
//       >
//         <Box
//           sx={{
//             width: "30%",
//             justifyContent: "center",
//             alignItems: "center",
//             display: "flex",
//           }}
//         >
//           <CardMedia
//             component="img"
//             sx={{
//               width: 60,
//               height: 60,
//               borderRadius: 1,
//               alignItems: "center",
//             }}
//             image={SampleImageCard}
//             alt={title}
//           />
//         </Box>

//         <Box sx={{ width: "60%" }}>
//           <Typography variant="h6" fontWeight="bold">
//             {title}
//           </Typography>
//           <Typography variant="h6" color="primary" mt={1}>
//             ₹{price}
//           </Typography>
//         </Box>
//         <Box sx={{ width: "10%" }}>
//           <IconButton
//             sx={{ top: 5, right: 5 }}
//             onClick={() => setShowModal(!showModal)}
//           >
//             <MoreVertIcon sx={{ cursor: "pointer" }} />
//           </IconButton>
//           {/* Menu Options */}
//           <Menu anchorEl={anchorEl} open={showModal} onClose={() => {}}>
//             <MenuItem onClick={() => {}}>
//               <EditIcon fontSize="small" sx={{ marginRight: 1 }} />
//               Edit
//             </MenuItem>
//             <Divider />
//             <MenuItem onClick={() => {}} sx={{ color: "error.main" }}>
//               <DeleteIcon fontSize="small" sx={{ marginRight: 1 }} />
//               Delete
//             </MenuItem>
//             <Divider />
//             <MenuItem
//               onClick={() => setShowModal(!showModal)}
//               sx={{ color: "error.main" }}
//             >
//               <DeleteIcon fontSize="small" sx={{ marginRight: 1 }} />
//               Cancel
//             </MenuItem>
//           </Menu>
//         </Box>
//       </Box>
//       <CardContent>
//         <Typography
//           variant="body2"
//           color="text.secondary"
//           fontWeight={"bold"}
//           fontSize={20}
//           sx={{ color: "black" }}
//         >
//           Product Description
//         </Typography>

//         <Typography variant="body2" color="text.secondary" mt={1}>
//           {summary}
//         </Typography>

//         {/* Sales and Product Status */}
//         {/* <Box mt={2} p={1} borderRadius={2} bgcolor="#f5f5f5">
//           <Stack spacing={1}>
//             <Box display="flex" justifyContent="space-between">
//               <Typography variant="body2" fontWeight="bold">
//                 SKU
//               </Typography>
//               <Box display="flex" alignItems="center">
//                 <ArrowUpwardIcon fontSize="small" color="warning" />
//                 <Typography ml={0.5} variant="body2">
//                   {sales}
//                 </Typography>
//               </Box>
//             </Box>
//             <LinearProgress
//               variant="determinate"
//               value={70}
//               sx={{
//                 height: 6,
//                 borderRadius: 3,
//                 "& .MuiLinearProgress-bar": { bgcolor: "orange" },
//               }}
//             />

//             <Box display="flex" justifyContent="space-between" mt={1}>
//               <Typography variant="body2" fontWeight="bold">
//                 Remaining Products
//               </Typography>
//               <Typography variant="body2">{remaining}</Typography>
//             </Box>
//             <LinearProgress
//               variant="determinate"
//               value={80}
//               sx={{
//                 height: 6,
//                 borderRadius: 3,
//                 "& .MuiLinearProgress-bar": { bgcolor: "orange" },
//               }}
//             />
//           </Stack>
//         </Box> */}
//       </CardContent>
//     </Card>
//   );
// };

// export default AdminProductCard;


import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Button,
} from "@mui/material";
import { ArrowUpward, MoreVert } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import CircleIcon from '@mui/icons-material/Circle';
const AdminProductCard = ({
  // title,
  // summary,
  // price,
  // sales,
  // remaining,
  // images, 
  data, onMenuClick,onDeleteClick,isEditing, status = 'active' 
}) => {
  
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const open = Boolean(anchorEl);
  console.log("iamges",data)
  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex < data.images.length - 1 ? prevIndex + 1 : 0
    );
  };

  
  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : data.images.length - 1
    );
  };

  return (
    <Card
      sx={{
        width: 250,
        margin: 2,
        borderRadius: 2,
        boxShadow: 3,
        overflow: "hidden",
      }}
    >
      {/* Carousel */}
      <Box sx={{ position: "relative", height: 180 }}>
  {data.images.length > 0 ? (
    <CardMedia
      component="img"
      image={data.images[currentImageIndex]?.image_url || ""}
      alt={data.name}
      sx={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
    />
  ) : (
    <Typography
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        color: "gray",
        fontStyle: "italic",
      }}
    >
      No image available
    </Typography>
  )}

  {/* Navigation buttons */}
  {data.images.length > 1 && (
    <>
      <IconButton
        sx={{ position: "absolute", top: "50%", left: 10, zIndex: 1 }}
        onClick={handlePrevImage}
      >
        {"<"}
      </IconButton>
      <IconButton
        sx={{ position: "absolute", top: "50%", right: 10, zIndex: 1 }}
        onClick={handleNextImage}
      >
        {">"}
      </IconButton>
    </>
  )}

  {/* Menu Button */}
  <IconButton
    sx={{ position: "absolute", top: 5, right: 5, zIndex: 2 }}
    onClick={(event) => setAnchorEl(event.currentTarget)}
  >
    <MoreVertIcon sx={{ cursor: "pointer" }} />
  </IconButton>

  {/* Menu Options */}
  <Menu
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={() => setAnchorEl(null)}
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
    transformOrigin={{ vertical: "top", horizontal: "right" }}
  >
      <MenuItem onClick={() => {
               onMenuClick(data);
               isEditing(true);
             }}>
      <EditIcon fontSize="small" sx={{ marginRight: 1 }} />
      Edit  
    </MenuItem>
    {/* <Divider />   onDeleteClick(data['product_id'])}*/}
    <MenuItem  onClick={() => {  
      console.log("clicked in adminProdCard",data.product_id?data?.product_id:data?.vlisting_id) 
      const deletedid=data.product_id?data?.product_id:data?.vlisting_id
      onDeleteClick(deletedid)
      }} sx={{ color: "error.main" }}>
      <DeleteIcon fontSize="small" sx={{ marginRight: 1 }} />
          Delete
    </MenuItem>
    {/* <Divider /> */}
    <MenuItem
      onClick={() => setAnchorEl(null)}
      sx={{ color: "error.main",display:'none' }}
    >
      <DeleteIcon fontSize="small" sx={{ marginRight: 1 }} />
      Cancel
    </MenuItem>
  </Menu>
</Box>

    

      <CardContent>
        <Typography variant="h6" fontWeight="bold">
          {data.name}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <CircleIcon 
              sx={{ 
                fontSize: 12, 
                color: status === 'active' ? '#4CAF50' : '#9e9e9e',
              }} 
            />
            <Typography 
              variant="caption" 
              sx={{ 
                color: status === 'active' ? '#4CAF50' : '#9e9e9e',
                fontWeight: 'medium'
              }}
            >
              {status}
            </Typography>
          </Box>
        <Typography variant="body2" color="text.secondary" mt={1} display={'none'}>
          {data.description}
        </Typography>
        <Typography variant="h6" color="primary" mt={1}>
          ₹{data.regularPrice? data.regularPrice : data.price}
        </Typography>
        
      </CardContent>
    </Card>
  );
};

export default AdminProductCard;




